/**
 * Ответ куратора HR на уточнение турагентства.
 *
 * Панель появляется, только когда бэк сказал `canAnswerAgency`: есть открытый вопрос И смотрящий
 * — кадровик компании заявки (или admin). Своей проверки прав здесь нет намеренно: правило живёт
 * на сервере, а дублирование быстро расходится с ним.
 *
 * Сам тред кадровик читает в «Истории» — реплики лежат там обычными событиями заявки; здесь
 * повторяется только последний вопрос, чтобы отвечать, не переключая вкладку.
 */
import { useState } from 'react'
import { Text, YStack } from 'tamagui'

import { useApp } from '../../../i18n'
import { tone } from '../../../theme/tones'
import { Button, FormTextArea } from '../../../ui'
import type { RequestCard } from '../../../lib/types'
import { errorText } from '../errorText'
import { lastAgencyQuestion } from '../processCard'
import { useAnswerAgency } from '../useEdo'

export function AgencyAnswerPanel({ card }: { card: RequestCard }) {
  const { t } = useApp()
  const [text, setText] = useState('')
  const answer = useAnswerAgency()
  const question = lastAgencyQuestion(card)
  if (!card.canAnswerAgency || !question) return null
  return (
    <YStack gap={8} backgroundColor={tone('gold').soft} borderRadius={8} padding={12}>
      <Text fontSize={13} fontWeight="700" color={tone('gold').text}>
        {t({ ru: 'Уточнение от турагентства', en: 'The travel agency asked a question', az: 'Turizm agentliyinin sualı' })}
      </Text>
      <Text fontSize={13} color="$color">
        {question.author ? `${question.author}: ${question.text}` : question.text}
      </Text>
      {/* TextArea, а не FormInput с multiline: у FormInput фиксированная высота, и поле
          обрезало даже плейсхолдер. Ответ — несколько строк про рейс и отель. */}
      <FormTextArea
        value={text}
        onChangeText={setText}
        placeholder={t({ ru: 'Ответ агентству', en: 'Answer to the agency', az: 'Agentliyə cavab' })}
        minHeight={120}
      />
      {answer.isError ? (
        <Text fontSize={12} color={tone('red').text}>
          {t(errorText(answer.error))}
        </Text>
      ) : null}
      <Button
        disabled={!text.trim() || answer.isPending}
        onPress={() => answer.mutate({ id: card.id, text: text.trim() }, { onSuccess: () => setText('') })}
      >
        {t({ ru: 'Ответить', en: 'Answer', az: 'Cavab ver' })}
      </Button>
    </YStack>
  )
}
